<template>
  <vue-bottom-sheet :background-clickable="false"
                    :background-scrollable="false"
                    :click-to-close="true"
                    :is-full-screen="true"
                    :maxHeight="'75%'"
                    :maxWidth="'95%'"
                    :overlay="true"
                    :rounded="true"
                    :swipe-able="true"
                    ref="tableSheet">
    <TableDetails @click="close" @updateAction="updateAction" :tab="tab"/>
  </vue-bottom-sheet>
</template>

<script>
import VueBottomSheet from "@webzlodimir/vue-bottom-sheet";
import TableDetails from "@/components/point-of-sale/table/TableDetails";

export default {
  name: "OpenTableSheet",
  components: {TableDetails, VueBottomSheet},
  props: {tab: {type: Object, required: true}},
  methods: {
    close() {
      try {
        this.$refs.tableSheet.close();
      } catch (e) {
        console.error(e);
      }
    },
    updateAction(){
      this.close()
      this.$emit(`updateAction`)
    },

    open() {
      try {
        this.$refs.tableSheet.open();
      } catch (e) {
        console.error(e)
      }
    },
  }
}
</script>

<style scoped>
:deep(.bottom-sheet__content) {
  background: var(--card-bg) !important;
  border: var(--card-border);
  box-shadow: var(--card-shadow);
}

:deep(.bottom-sheet) {
  background: var(--bg-primary) !important;
}

:deep(.bottom-sheet__backdrop) {
  background: rgba(0, 0, 0, 0.5) !important;
}
</style>
